import React from "react";
import PropTypes from "prop-types";

import * as R from "ramda";

import { Link } from "react-router-dom";

const Header = ({ email, role, pages }) => (
  <header>
    <nav className="navbar navbar-expand-sm bg-white">
      <div className="container">
        <button
          className="navbar-toggler col-2"
          type="button"
          data-toggle="collapse"
          data-target="#navbar-list-menu"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon">
            <i className="icono-options-alternate" />
          </span>
        </button>
        <h1 aria-label="Logotipo CEPSA" className="brand-cepsa">
          <Link className="navbar-brand" to="/">
            <i className="icono-cepsa-symbol d-none d-sm-block">&nbsp;</i>
            <i className="icono-cepsa-text d-block d-sm-none">&nbsp;</i>
          </Link>
        </h1>

        <div className="collapse navbar-collapse justify-content-between" id="navbar-list-menu">
          <ul className="navbar-nav active">
            {pages.map(({ name, path, active }) => (
              <li className={`nav-item ${active ? "active" : ""}`}>
                <Link className="nav-link" to={path}>
                  {name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="right-side d-flex">
          <ul className="navbar-nav">
            {/* <li className="nav-item dropdown">
              <UncontrolledButtonDropdown nav inNavbar>
                <DropdownToggle nav caret className="navbar-notify">
                  <i className="icono-bell" />
                  <span className="badge badge-pill badge-notify"> </span>
                </DropdownToggle>
                <DropdownMenu right className="menu-notify">
                  <DropdownItem className="dropdown-item item-notify">
                    <div>Tiene pendiente 5 transferencias por conciliar</div>
                    <small className="text-muted">Recibido hace 1 día</small>
                  </DropdownItem>
                  <DropdownItem divider />
                  <DropdownItem className="footer-notify">
                    VER TODAS LAS NOTIFICACIONES
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledButtonDropdown>
            </li> */}
            <li className="nav-item dropdown">
              {/* <UncontrolledButtonDropdown nav inNavbar>
                <DropdownToggle nav caret className="navbar-user"> */}

              <div className="nav navbar-user">
                <div className="rounded-circle">
                  <span className="user-acronym">
                    <span className="icono-person" />
                  </span>
                </div>
                <span className="user-name">
                  {`${email}${role && !R.isEmpty(role) ? ` (${role})` : ""}`}
                </span>
              </div>

              {/* </DropdownToggle> */}
              {/* <DropdownMenu right className="menu-user">
                  <DropdownItem>Cerrar sesión</DropdownItem>
                </DropdownMenu> */}
              {/* </UncontrolledButtonDropdown> */}
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </header>
);

Header.propTypes = {
  email: PropTypes.string,
  role: PropTypes.string,
  pages: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      path: PropTypes.string,
      active: PropTypes.bool
    })
  )
};

Header.defaultProps = {
  email: "",
  role: "",
  pages: [{ name: "Conciliaciones", path: "/", active: true }]
};

export default Header;
